import { Clock } from 'lucide-react'

import { SolidAlertCircleIcon, SolidCircleCheckIcon, SolidCircleXIcon } from 'slab'
import { AdminComplianceCheckState } from 'utils/web_api.schemas'

interface EmployerChecksStatusProps {
  checks: Array<{
    state: AdminComplianceCheckState
    id: string
    policy_type: string
  }>
}

const getStatusIcon = (state: AdminComplianceCheckState) => {
  switch (state) {
    case AdminComplianceCheckState.passed:
      return <SolidCircleCheckIcon aria-label='(complete)' className='text-green-500' size={16} />
    case AdminComplianceCheckState.failed:
      return <SolidCircleXIcon aria-label='(failed)' className='text-red-500' size={16} />
    case AdminComplianceCheckState.errored:
    case AdminComplianceCheckState.expired:
      return <SolidAlertCircleIcon aria-label='(expired)' className='text-yellow-500' size={16} />
    case AdminComplianceCheckState.processing:
    case AdminComplianceCheckState.queued_for_invite:
    case AdminComplianceCheckState.invite_sent:
    case AdminComplianceCheckState.invite_opened:
      return <Clock aria-label='(processing)' className='text-gray-500' size={16} />
  }
}

const EmployerChecksStatus = ({ checks }: EmployerChecksStatusProps) => {
  if (!checks || checks.length === 0) {
    return <span className='text-gray-400 font-light'>&mdash;</span>
  }

  return (
    <div className='flex items-center gap-1'>
      {checks.map((check) => {
        const IconComponent = getStatusIcon(check.state)

        return (
          <div
            key={check.id}
          >
            {IconComponent}
          </div>
        )
      })}
    </div>
  )
}

export default EmployerChecksStatus
